// CSS
import '../../styles/main.css'

// Components
import { Heading, TypographyColor, TypographyType } from "../../ui-elements";

// Utilities

export const CustomTooltip = ({ active, payload }: any) => {

    if (active && payload && payload.length && payload[0].payload) {
        return (
            <div className="poi-chart-custom-tooltip padding-2 rounded d-flex flex-column align-items-start justify-content-center" >
                <Heading
                    title={`${payload[0].payload.date}`}
                    type={TypographyType.h5}
                    colour={TypographyColor.blue}
                    classname='p-0 m-0'
                />
                <Heading
                    title={`PoI ${payload[0].payload.displayValue}`}
                    type={TypographyType.h5}
                    colour={TypographyColor.blue}
                    classname='p-0 m-0'
                />
                {payload[0].payload.description && (payload[0].payload.averageDisplayValue !== undefined || payload[0].payload.averageDisplayValue !== null) &&
                    <div className="p-0 m-0">
                        <Heading
                            title={payload[0].payload.description}
                            type={TypographyType.h6}
                            colour={TypographyColor.secondary}
                            classname='p-0 m-0'
                        />
                        <Heading
                            title={`PoI ${payload[0].payload.averageDisplayValue}`}
                            type={TypographyType.h6}
                            colour={TypographyColor.secondary}
                            classname='p-0 -0'
                        />
                    </div>
                }
            </div>
        );
    }
    return null;
};